module.exports = __webpack_public_path__ + "img/38846-080.ab4e461e.jpg";